<!-- (1.1.1) バウンド番号
  1からの連番を含む、何番目のバウンドかの文言を表示する。-->
<h3
  class="p-trip-summary__title-label c-bound-title01"
  [innerHTML]="'label.number.section.n' | staticMsg : { '0': boundIdx + 1 }"
  role="heading"
  aria-level="3"
></h3>
<!-- (1.1.2) 欠航・遅延・早発情報 -->
<div class="p-trip-summary__title-tag" *ngFor="let status of boundStatus">
  <div class="p-trip-summary__title-tag-item">
    <span class="c-tag c-tag--type01">
      <strong [innerHTML]="status.label | staticMsg"></strong>
    </span>
  </div>
  <!-- (1.1.5) 欠航理由 & (1.1.8) 遅延理由 & (1.1.11) 早発理由
    3) 以下の条件に応じて表示する。
    3.1) 早発理由 = ""(空欄)の場合、非表示とする。
    3.2) 早発理由 ≠ ""(空欄)の場合、早発理由を表示する。-->
  <div *ngIf="status.reasons" class="p-trip-summary__title-tag-item">
    <em>
      <span
        class="p-trip-summary__title-tag-status p-trip-summary__title-tag-status--red"
        [innerHTML]="status.reasons"
      ></span>
    </em>
  </div>
</div>
<!-- (1.1.64) イレギュラー補填リンク -->
<div class="p-trip-summary__title-tag" *ngIf="bound.isIrregularCompensationEligible">
  <div
    class="p-trip-summary__title-tag-item p-trip-summary__title-tag-item--mt0"
    [innerHTML]="'label.compensationLink' | staticMsg"
  ></div>
</div>
<!-- (1.1.12) Dynamic Waiver対象 -->
<ng-container *ngIf="getDynamicWaiver(); let waiverLabel">
  <div class="p-trip-summary__title-tag">
    <div class="p-trip-summary__title-tag-item">
      <span class="c-text-with-tooltip">
        <span class="c-text-with-tooltip__text">
          <span class="c-tag c-tag--type04" [innerHTML]="waiverLabel | staticMsg"></span>
        </span>
      </span>
      <!-- (1.1.65) ヘルプアイコン -->
      <asw-tooltip
        [iconImage]="
          tripSummarySvc.buildTooltipIcon(
            'icon_help_primary_20.svg',
            'm_static_message-alt.helpIcon2' | staticMsg,
            '20'
          )
        "
        [tooltipContent]="getFeeWaiverTooltip() | staticMsg"
      ></asw-tooltip>
    </div>
  </div>
</ng-container>
<!-- (1.1.13) 出発日(バウンド) -->
<div class="p-trip-summary__title-date" [innerHTML]="getOriginDepartureDateTime()"></div>
<!-- (1.1.14) 総所要時間
  以下の条件に応じて表示する。
  1) 当該バウンド.originDepartureDateTime が存在しない場合、非表示とする。
  2) 当該バウンド.originDepartureDateTime が存在する場合、
  当該バウンド.duration を表示する。-->
<div
  *ngIf="bound.originDepartureDateTime"
  class="p-trip-summary__title-elapsed"
  [innerHTML]="boundDuration | dateFormat : 'default_flightTotalTime'"
></div>
